
import QueryDetails from './QueryDetails-container';

export default QueryDetails;